import { makeObservable, observable } from 'mobx';
import { IOrganizationListingModel, IOrderByParams, ClientConfigurationModel, OrganizationListingModel } from '@common/models';
import * as enums from '@common/models/Enums';
import { StandardSearchStore } from '@common/stores';
import { SearchService } from '@common/services/searchService';

const defaultOrgSearchOrder: Array<IOrderByParams> = [
    { field: "name", dir: "asc" }
]

export interface IOrganizationSearchFilter {
    searchTerm?: string,
    organizationVersionId: number,
    relatedKey?: string,
    notRelatedKey?: string,
    typeId?: number
}

const defaultOrgSearchFilter: IOrganizationSearchFilter = {
    searchTerm: undefined,
    organizationVersionId: 1,
    relatedKey: undefined,
    notRelatedKey: undefined,
    typeId: enums.OrganizationTypes.Hospital
}

export interface OrganizationSearchStoreInit {
    configuration: ClientConfigurationModel,
    organizationTypeId?: enums.OrganizationTypes,
    notRelatedKey?: string,
    relatedKey?: string
}

/**
 * Extend the SearchStore to setup for Organization Search with necessary default filters and searchParams and entityName.
 * We can follow a similar pattern for any store that needs to use the SearchService
 */
export class OrganizationSearchStore extends StandardSearchStore<IOrganizationSearchFilter, IOrganizationListingModel, OrganizationListingModel> {
    @observable configuration: ClientConfigurationModel;
    constructor(init: OrganizationSearchStoreInit) {
        super({
            endpointUrl: SearchService.SearchEndPoints.organizations,
            defaultSearchParams: {
                orderby: defaultOrgSearchOrder,
                top: 10
            },
            defaultSearchFilter: {
                ...defaultOrgSearchFilter, typeId: init.organizationTypeId, notRelatedKey: init.notRelatedKey, relatedKey: init.relatedKey
            },
        }, (result: IOrganizationListingModel) => new OrganizationListingModel(result));

        this.configuration = init.configuration;
        this.setPartialDefaultSearchFilter({ organizationVersionId: this.configuration.currentCorpOrganization.organizationVersionId });
        makeObservable(this, undefined); //can't use autoBind in derrived class if already called in sub class.
    }
}
